import React from 'react';
import cx from 'classnames';
import { shape, func, string } from 'prop-types';

import Link from 'components/Link';
import { ChevronIcon } from 'components/Icon';

import useStyles from 'hooks/useStyles';

import styles from './MobileBreadcrumb.scss';

const MobileBreadcrumb = ({ className, onClick, path }) => {
  useStyles(styles);

  const handleClick = link => typeof onClick === 'function' && onClick(link);

  return (
    <div className={cx(styles.root, className)}>
      <ChevronIcon width={24} height={24} className={styles.icon} />
      <Link to={path.link} className={styles.link} onClick={handleClick}>
        {path.label}
      </Link>
    </div>
  );
};

MobileBreadcrumb.propTypes = {
  path: shape({
    label: string,
    link: string,
  }).isRequired,
  className: string,
  onClick: func,
};

MobileBreadcrumb.defaultProps = {
  className: undefined,
  onClick: null,
};

export default MobileBreadcrumb;
